<template>
  <header class="header">
    <div class="container">
      <div class="header-content">
        <div class="logo">
          <router-link to="/">
            <img src="@/assets/images/logo.png" alt="中国企业走出去风险发布会">
          </router-link>
        </div>
        <nav class="nav-desktop">
          <ul>
            <li><router-link to="/" exact-active-class="active">风险发布会</router-link></li>
            <li><router-link to="/alliance" active-class="active">国际合作联盟</router-link></li>
            <li><router-link to="/rescue-alliance" active-class="active">全球救援联盟</router-link></li>
            <li><router-link to="/results" active-class="active">大会成果</router-link></li>
          </ul>
        </nav>
        <div class="user-auth">
          <!-- Not Logged In State -->
          <template v-if="!isLoggedIn">
            <button class="auth-btn login-btn" @click="showLoginModal('login')">登录</button>
            <button class="auth-btn register-btn" @click="showLoginModal('register')">申请加入</button>
          </template>
          
          <!-- Logged In State -->
           <div v-else class="user-info">
            <div class="user-icon">
              <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23004a99'%3E%3Cpath d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z'/%3E%3C/svg%3E" alt="用户">
              <span class="user-name">{{ userInfo  }}</span>
              <div class="user-dropdown">
                <ul>
                  <li><a href="#" @click.prevent="showDownloadHistory">下载记录</a></li>
                  <li><a href="#" @click.prevent="logout">退出登录</a></li>
                </ul>
              </div>
            </div>
           </div>
          
        </div>
        <div class="menu-toggle" @click="toggleMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="mobile-menu" :class="{ 'active': menuActive }">
      <nav class="nav-mobile">
        <ul>
          <li><router-link to="/" exact-active-class="active" @click="closeMenu">风险发布会</router-link></li>
          <li><router-link to="/alliance" active-class="active" @click="closeMenu">国际合作联盟</router-link></li>
          <li><router-link to="/rescue-alliance" active-class="active" @click="closeMenu">全球救援联盟</router-link></li>
          <li><router-link to="/results" active-class="active" @click="closeMenu">大会成果</router-link></li>
          <template v-if="isLoggedIn">
            <li class="divider"></li>
            <li><a href="#" @click.prevent="showDownloadHistory">下载记录</a></li>
            <li><a href="#" @click.prevent="logout">退出登录</a></li>
          </template>
            <template v-else>
            <li class="divider"></li>
            <li><a href="#" @click.prevent="showLoginModal('login')">登录</a></li>
            <li><a href="#" @click.prevent="showLoginModal('register')">申请加入</a></li>
          </template>
        </ul>
      </nav>
    </div>
    <loginOrRegister ref="loginOrRegister"></loginOrRegister>
    <recordList ref="recordList"></recordList>
  </header>
</template>

<script>
import authService from '@/service/auth.service.js'
import loginOrRegister from './loginOrRegister.vue'
import recordList from './recordList.vue'

export default {
  name: 'Header',
  components: {
    loginOrRegister,
    recordList
  },
  data() {
    return {
      codeImg: '',
      imgCode: '',
      menuActive: false,
      downloadHistoryVisible: false,
      currentPage: 1,
      total: 0,
      windowWidth: window.innerWidth,
      // User authentication state
      isLoggedIn: false,
      
      // Login modal
      loginModalVisible: false,
      loginForm: {
        phone: '',
        smsCode: '',
        captcha: ''
      },
      
      // Register modal
      registerModalVisible: false,
      registerForm: {
        phone: '',
        smsCode: '',
        captcha: '',
        name: '',
        company: '',
        position: '',
        email: '',
        category: ''
      },
      
      // SMS verification
      smsButtonText: '获取验证码',
      smsButtonDisabled: false,
      smsCountdown: 60,
      smsTimer: null,
      
      // Captcha
      captchaLoading: false,
      userInfo: '',
    }
  },
  computed: {
  },
  methods: {
    toggleMenu() {
      this.menuActive = !this.menuActive;
      document.body.style.overflow = this.menuActive ? 'hidden' : '';
    },
    closeMenu() {
      this.menuActive = false;
      document.body.style.overflow = '';
    },
    // Authentication methods
    showLoginModal(type) {
      this.$refs.loginOrRegister.showLoginModal(type)
    },

    logout() {
      this.isLoggedIn = false
      localStorage.clear();
      this.$message.success('已退出登录')
      // 刷新页面以更新所有组件状态
      window.location.reload();
    },
    // Existing methods for download history
    showDownloadHistory() {
      this.$refs.recordList.showDownloadHistory()
    },
    
    handleResize() {
      this.windowWidth = window.innerWidth
    },

    getCaptcha() {
      this.captchaLoading = true
      authService.getCaptcha()
        .then(res => {
          this.codeImg = res.data;
          this.imgCode = res.header.imgcode;
        })
        .catch(error => {
          console.error('获取验证码失败:', error)
          this.$message.error('获取验证码失败，请稍后重试')
        })
        .finally(() => {
          this.captchaLoading = false
        })
    }
  },
  mounted() {
    // Add resize event listener
    window.addEventListener('resize', this.handleResize)
    this.getCaptcha()
    this.isLoggedIn = localStorage.getItem('token') ? true : false;
    this.userInfo = localStorage.getItem('userName') ? localStorage.getItem('userName') : '';
  },
  // beforeDestroy() {
  //   // Remove resize event listener
  //   window.removeEventListener('resize', this.handleResize)
    
  //   // Clear SMS timer if exists
  //   if (this.smsTimer) {
  //     clearInterval(this.smsTimer)
  //   }
  // }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.logo img {
  height: 40px;
}

.nav-desktop ul {
  display: flex;
  list-style: none;
}

.nav-desktop ul li {
  margin-left: 30px;
}

.nav-desktop ul li a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.3s;
  position: relative;
  padding-bottom: 5px;
}

.nav-desktop ul li a:hover, .nav-desktop ul li a.active {
  color: #004a99;
}

.nav-desktop ul li a.active::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #004a99;
}

.user-auth {
  display: flex;
  align-items: center;
}

.auth-btn {
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
  margin-left: 10px;
  border: none;
  transition: all 0.3s ease;
}

.login-btn {
  background-color: #fff;
  color: #004a99;
  border: 1px solid #004a99;
}

.login-btn:hover {
  background-color: #e6f0ff;
}

.register-btn {
  background-color: #004a99;
  color: #fff;
}

.register-btn:hover {
  background-color: #003b7a;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-icon {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 20px;
  transition: background-color 0.3s;
}

.user-icon:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.user-icon img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.user-name {
  font-size: 14px;
  color: #333;
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  width: 120px;
  display: none;
  z-index: 1000;
}

.user-icon:hover .user-dropdown {
  display: block;
}

.user-dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.user-dropdown li {
  padding: 0;
}

.user-dropdown li a {
  display: block;
  padding: 10px 15px;
  color: #333;
  text-decoration: none;
  font-size: 14px;
  transition: background-color 0.3s;
}

.user-dropdown li a:hover {
  background-color: #f5f5f5;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 30px;
  height: 21px;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: #333;
  transition: all 0.3s;
}

.mobile-menu {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100vh - 70px);
  background-color: #fff;
  z-index: 999;
  transform: translateX(100%);
  transition: transform 0.3s;
  overflow-y: auto;
}

.mobile-menu.active {
  transform: translateX(0);
}

.nav-mobile ul {
  list-style: none;
  padding: 20px;
}

.nav-mobile ul li {
  margin-bottom: 20px;
}

.nav-mobile ul li a {
  display: block;
  text-decoration: none;
  color: #333;
  font-size: 1.2rem;
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.nav-mobile ul li a.active {
  color: #004a99;
}

@media (max-width: 768px) {
  .nav-desktop, .user-auth {
    display: none;
  }
  
  .menu-toggle {
    display: flex;
  }
  
  .header-content {
    height: 60px;
  }
  
  .mobile-menu {
    top: 60px;
    height: calc(100vh - 60px);
  }
  
  .logo img {
    height: 30px;
  }
}
/* Responsive styles */
@media (max-width: 767px) {
  .auth-btn {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 479px) {
  .auth-btn {
    padding: 5px 10px;
    font-size: 12px;
  }
}
</style> 